module.exports = __webpack_public_path__ + "media/images/area/area_osakaM400-bc4606a8d5a847da0bd6b4770dbc1f83.jpg";